import { api } from "@/api/client";
import type { UsageResponse } from "@/api/types";

export const getStorageUsage = () => api.get<UsageResponse>("/v1/storage/usage");
